var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11C7.2 11 6.80556 10.8389 6.48333 10.5167C6.16111 10.1945 6 9.80004 6 9.33337C6 8.86671 6.16111 8.47226 6.48333 8.15004C6.80556 7.82782 7.2 7.66671 7.66667 7.66671C8.13333 7.66671 8.52778 7.82782 8.85 8.15004C9.17222 8.47226 9.33333 8.86671 9.33333 9.33337C9.33333 9.80004 9.17222 10.1945 8.85 10.5167C8.52778 10.8389 8.13333 11 7.66667 11ZM1.33333 13.6667C0.966667 13.6667 0.652667 13.5363 0.391333 13.2754C0.130444 13.014 0 12.7 0 12.3334V3.00004C0 2.63337 0.130444 2.3196 0.391333 2.05871C0.652667 1.79737 0.966667 1.66671 1.33333 1.66671H2V0.333374H3.33333V1.66671H8.66667V0.333374H10V1.66671H10.6667C11.0333 1.66671 11.3473 1.79737 11.6087 2.05871C11.8696 2.3196 12 2.63337 12 3.00004V12.3334C12 12.7 11.8696 13.014 11.6087 13.2754C11.3473 13.5363 11.0333 13.6667 10.6667 13.6667H1.33333ZM1.33333 12.3334H10.6667V5.66671H1.33333V12.3334ZM1.33333 4.33337H10.6667V3.00004H1.33333V4.33337ZM1.33333 4.33337V3.00004V4.33337Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.0943975ca1f2a810bf8cd7f4e7202be8.svg";
export { ForwardRef as ReactComponent };